import type { ReactNode } from 'react'

// Numerals/timers/money/order-codes stay LTR even when the page is mirrored RTL
// (design guidance, bench-HOP-ORDER-DETAIL.CB-A). <bdi> bidi-isolates the run from
// surrounding Arabic text so punctuation/currency symbols don't get reordered.
export function Ltr({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <bdi dir="ltr" className={className}>
      {children}
    </bdi>
  )
}
